import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { SettingsModel } from '../models';
import { of } from 'rxjs';
import { PermissionService } from './permission.service';
import { environment as env } from '../../../environments/environment';
import { map, timeout, retry, catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from 'app/shared/info-dialog/info-dialog.component';
import {GeneralService} from './general.service';

const settingURL = 'environments/appsettings.json';

@Injectable()
export class SettingsProvider {

  private config: any;

  constructor(
    private http: HttpClient,
    private permissionService: PermissionService,
    private dialog: MatDialog,
    private generalService: GeneralService
  ) { }

  public loadConfig(): Promise<any> {
    return this.http.get(settingURL)
      .toPromise()
      .then(settings => this.config = settings)
      .then(_ => {
        if (this.checkIfLoggedIn()) {
          return this.loadPermissions();
        } else {
          return [];
        }
      })
      .then(perms => this.permissionService.setPermissions(perms));
  }

  private checkIfLoggedIn(): boolean {
    return !!sessionStorage.getItem('adal.idtoken');
  }

  private prepareOptions(type: string, token: string): any {
    let headers = new HttpHeaders();
    headers = headers
      .set('Accept', type)
      .set('Content-Type', type)
      .set('Authorization', `Bearer ${token}`);
    return { headers };
  }

  // token is taken from SessionStorage
  // retry one more time if request takes longer than 3000
  // TODO: check what is with Adal6Service??
  public loadPermissions(): Promise<any> {
    const url = `${this.configuration.url}${env.ProfileDataService.apiUrlGetProfilePermissionsList}`;
    const token = sessionStorage.getItem('adal.idtoken');
    const options = this.prepareOptions('application/json', token);
    return this.http.get(url, options)
      .pipe(
        timeout(3000),
        retry(2),
        map((request: any) => this.generalService.toUpperCamelCaseObj(request.items)),
        catchError(err => {
          if (err && err.status && err.status === 403) {
            setTimeout(() => this.openDialog(), 1000);
          }
          return of([]);
        })
      )
      .toPromise();
  }

  public get configuration(): SettingsModel {
    return this.config;
  }

  public openDialog(): void {
    const dialogRef = this.dialog.open(InfoDialogComponent, {
      width: '350px',
      data: { title: 'Uwaga', text: 'Konto użytkownika nieaktywne', canClose: false },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('info closed');
    });
  }
}
